import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string; // newline-separated
  addonPrice?: number;
  required?: boolean;
  disabled?: boolean;
  forcedValue?: string | null;
  error?: string;
}

export function SelectField({
  label,
  value,
  onChange,
  options: optionsRaw,
  addonPrice,
  required = false,
  disabled = false,
  forcedValue,
  error,
}: SelectFieldProps) {
  const isForced = forcedValue !== null && forcedValue !== undefined;
  const displayValue = isForced ? forcedValue : value;

  const optionsList = optionsRaw
    .split('\n')
    .map((o) => o.trim())
    .filter(Boolean);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-foreground">
          {label}
          {required && <span className="ml-0.5 text-red-500">*</span>}
        </label>
        {addonPrice != null && addonPrice > 0 && (
          <span className="rounded-full bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-700 dark:bg-sky-950 dark:text-sky-300">
            +฿{addonPrice.toLocaleString()}
          </span>
        )}
      </div>

      <Select
        value={displayValue || undefined}
        onValueChange={(v) => {
          if (!isForced) onChange(v);
        }}
        disabled={disabled || isForced}
      >
        <SelectTrigger
          className={error ? 'border-red-500' : ''}
          aria-invalid={!!error}
        >
          <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
        </SelectTrigger>
        <SelectContent>
          {optionsList.map((opt) => (
            <SelectItem key={opt} value={opt}>
              {opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}
